import Component from '@glimmer/component';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import type Store from '@ember-data/store';
import { trackedFunction } from 'reactiveweb/function';
import { Select } from 'tio-ui/components/forms';
import type CompanyModel from '../../models/company';

export interface SelectCompanySignature {
  Args: {
    label?: string;
    onSelectionChange: (company?: CompanyModel) => void;
    placeholder?: string;
    selected?: string | null;
    inputSize?: 'sm' | 'md' | 'lg';
  };
  Element: HTMLDivElement;
}

export default class SelectCompanyComponent extends Component<SelectCompanySignature> {
  @service declare store: Store;

  onSelectionChange = (key: string | null) => {
    this.args.onSelectionChange?.(this.companyOptions.find((company) => company.id === key));
  };

  companyData = trackedFunction(this, async () => {
    return this.store.query<CompanyModel>('company', {
      filter: {
        'is-active': 1,
      },
      page: {
        limit: 400,
      },
    }) as Promise<CompanyModel[]>;
  });

  get companyOptions(): CompanyModel[] {
    return this.companyData.value || [];
  }

  <template>
    <Select
      @inputSize={{if @inputSize @inputSize}}
      @label={{if @label @label (t "eligibility_files.select_partner")}}
      @isFilterable={{true}}
      @placeholder={{if @placeholder @placeholder (t "eligibility_files.select_partner")}}
      @items={{this.companyOptions}}
      @selectedKey={{@selected}}
      @onSelectionChange={{this.onSelectionChange}}
      @isClearable={{true}}
      {{! @glint-expect-error: autocomplete and spellcheck are not typed on Select component }}
      autocomplete="off"
      spellcheck="false"
      ...attributes
    />
  </template>
}
